import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearMappingBackUrl} from "../config/crystalclear-mapping-back-url";
import {Fee} from "../../model/mapping/fee";

@Injectable({
  providedIn: 'root'
})
export class MappingFeeService extends CommonCrudService<Fee> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearMappingBackUrl.GET_MAPPING_FEE_LIST,
      CrystalclearMappingBackUrl.SAVE_MAPPING_FEE,
      CrystalclearMappingBackUrl.DELETE_MAPPING_FEE);
  }

}
